import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { AppRoutingModule } from 'src/app/app-routing.module';
import { MaterialModule } from 'src/app/material.module';
import { DirectivesModule } from '../directives/module';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { RelatedContentList } from './components/list/component';
import { RelatedContentApiService } from './services/related-content-api-service';
import { RelatedContentAdd } from './components/add/component';

@NgModule({
    imports: [
        CommonModule,
        MaterialModule,
        DirectivesModule,
        AppRoutingModule
    ],
    declarations: [RelatedContentList, RelatedContentAdd],
    exports: [RelatedContentList, RelatedContentAdd],
    providers: [RelatedContentApiService, {provide: MAT_DATE_LOCALE, useValue: 'en-GB'}],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})

export class RelatedContentModule {}